<template>
  <div class="empty-state-content">
    <div class="empty-state" :class="emptyEmptyClassName">
      <slot name="emptyIcon">
        <div class="empty-icon">
          <img :src="emptyInfos.emptyIcon" alt="" class="empty-img" />
        </div>
      </slot>
      <slot name="emptyTitle">
        <div class="empty-title">{{ emptyInfos.emptyTitle }}</div>
      </slot>
      <slot name="emptyDesc">
        <div class="empty-desc">{{ emptyInfos.emptyDesc }}</div>
      </slot>
      <slot name="emptyAction">
        <div class="empty-action" v-if="emptyInfos.emptyAction">
          <el-button @click="tryAgain" outline>{{
            emptyInfos.emptyActionText || $t('重试')
          }}</el-button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/locale';
import { mapState } from 'vuex';

import NOT_THE_KAESONG from '@/assets/images/didi/not_the_kaesong.png';
import NOT_RESULT_DATA from '@/assets/images/didi/no_result_icon.png';
import NO_NETWORK from '@/assets/images/didi/no_network.png';
import NO_RECENT_ORDER from '@/assets/images/didi/no_recent_order.png';
import NO_REWARDS from '@/assets/images/didi/no_rewards.png';
import NO_NETWORK_ENTREGA from '@/assets/images/didi/entrega_err.png';
import NO_SHOP from '@/assets/images/didi/no_shop.png';

Object.freeze(NOT_THE_KAESONG);
Object.freeze(NOT_RESULT_DATA);
Object.freeze(NO_NETWORK);
Object.freeze(NO_RECENT_ORDER);
Object.freeze(NO_REWARDS);
Object.freeze(NO_NETWORK_ENTREGA);
Object.freeze(NO_SHOP);
const emptyTypeDefault = {
  // 未开城
  notTheKaesong: {
    emptyType: 'notTheKaesong',
    emptyIcon: NOT_THE_KAESONG,
    emptyTitle: i18n.t('您所在的地区还未开通服务'),
    emptyDesc: i18n.t('您所在的地区还未开通服务'),
    emptyAction: false,
  },
  //没开通storefont
  noStoreFont: {
    emptyType: 'storeFont',
    emptyIcon: NO_SHOP,
    emptyTitle: i18n.t('FoodC_Storefront_Fzba_uHgH'),
    emptyDesc: i18n.t('FoodC_Storefront_iOFy_aaef'),
    emptyAction: false,
  },
  // 没数据返回
  notResultData: {
    emptyType: 'notResultData',
    emptyIcon: NOT_RESULT_DATA,
    emptyTitle: i18n.t('抱歉，未找到任何结果'),
    emptyDesc: i18n.t('试试减少筛选条件'),
    emptyAction: true,
  },
  // 没数据返回
  netNotResultData: {
    emptyType: 'netNotResultData',
    emptyIcon: NOT_RESULT_DATA,
    emptyTitle: i18n.t('抱歉，未找到任何结果'),
    emptyDesc: '',
    emptyAction: true,
  },
  // 没网络
  noNetwork: {
    emptyType: 'noNetwork',
    emptyIcon: NO_NETWORK,
    emptyTitle: i18n.t('网络异常'),
    emptyDesc: i18n.t('请检查网络连接'),
    emptyAction: true,
  },
  // 没网络(闪送)
  noNetworkEntrega: {
    emptyType: 'noNetworkEntrega',
    emptyIcon: NO_NETWORK_ENTREGA,
    emptyTitle: i18n.t('网络异常'),
    emptyDesc: i18n.t('请检查网络连接'),
    emptyAction: true,
  },
  // 没有最近的订单
  noRecentOrders: {
    emptyType: 'noRecentOrders',
    emptyIcon: NO_RECENT_ORDER,
    emptyTitle: i18n.t('暂无订单'),
    emptyDesc: '',
    emptyAction: false,
  },
  // 没有奖励
  noRewards: {
    emptyType: 'noRewards',
    emptyIcon: NO_REWARDS,
    emptyTitle: i18n.t('FoodC_all_No_reward_ocGJ'),
    emptyDesc: i18n.t('FoodC_all_You_haven_lSmt'),
    emptyAction: false,
  },
  // 没有商超
  noGrocery: {
    emptyType: 'noGrocery',
    emptyIcon: NOT_RESULT_DATA,
    emptyTitle: i18n.t('Groceries_web__Ovnh'),
    emptyAction: true,
    emptyActionText: i18n.t('FoodC_page__KWIm'),
  },
};

export default {
  name: 'EmptyState',
  props: {
    emptyType: {
      type: String,
    },
    emptyIcon: {
      type: String,
    },
    emptyTitle: {
      type: String,
    },
    emptyDesc: {
      type: String,
    },
    emptyAction: {
      type: Boolean,
    },
  },
  watch: {
    emptyType: {
      handler(newV) {
        this.emptyInfos.emptyType =
          this.emptyType || emptyTypeDefault[newV]?.emptyType;
        this.emptyInfos.emptyIcon =
          this.emptyIcon || emptyTypeDefault[newV]?.emptyIcon;
        this.emptyInfos.emptyTitle =
          this.emptyTitle || emptyTypeDefault[newV]?.emptyTitle;
        this.emptyInfos.emptyDesc =
          this.emptyDesc || emptyTypeDefault[newV]?.emptyDesc;
        this.emptyInfos.emptyAction =
          this.emptyAction || emptyTypeDefault[newV]?.emptyAction;
        this.emptyInfos.emptyActionText =
          this.emptyActionText || emptyTypeDefault[newV]?.emptyActionText;
        if (this.isFeed && newV === 'notResultData') {
          this.sailing_c_x_homepage_filter_none_sw();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      filterListIds: ({ feed }) => feed.filterListIds,
    }),
    emptyEmptyClassName() {
      return this.emptyInfos?.emptyType;
    },
    isFeed() {
      return this.$route?.path.includes('feed');
    },
  },
  data() {
    return {
      emptyInfos: {
        emptyType: '',
        emptyIcon: '',
        emptyTitle: '',
        emptyDesc: '',
        emptyAction: true,
      },
    };
  },
  mounted() {},
  methods: {
    tryAgain() {
      this.$emit('tryAgain');
    },
    sailing_c_x_homepage_filter_none_sw() {
      if (this.filterListIds) {
        this.$trackEvent({
          eventId: 'sailing_c_x_homepage_filter_none_sw',
          eventLabel: '首页综合筛选面板-筛选无结果曝光',
          attrs: {
            meta: {
              filterList: this.filterListIds,
            },
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
